// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Autocomplete,
  TextField,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import { useFindUsersByCategoryMutation } from '../../store/api/userApi';
import { getUserDetails } from '../../store/state/userSlice';
import { useFindByUserIdMutation } from '../../store/api/notesApi';
import { getNote, getNoteTotalRecord, reset, setNote } from '../../store/state/notesSlice';
import { fDateTimeSuffix } from '../../utils/formatTime';

const TABLE_HEAD = [
  { id: 'description', label: 'Note Comments', alignRight: false },
  { id: 'createdBy', label: 'Note Creator', alignRight: false },
  { id: 'createdDate', label: 'Date Created', alignRight: false },
  { id: '' },
];

export default function Notes() {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const [notesData, setNotesData] = useState([]);
  const notesTotalRecord = useAppSelector(getNoteTotalRecord);
  const getnotesData = useAppSelector(getNote);
  const userData = useAppSelector(getUserDetails);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [email, setEmail] = useState<any>([]);
  const [selectedOptions, setSelectedOptions] = useState() as any;
  const [getAllEmail, EmailResponse] = useFindUsersByCategoryMutation();
  const [notesValue, setNotesValue] = useState('');
  const [noteData, noteDataResponse] = useFindByUserIdMutation();

  const selectItems = (option: any, event: any) => {
    if (option !== null && option !== undefined) {
      setSelectedOptions(option == null ? null : option);
      noteData({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          userId: selectedOptions.id,
        },
      });
    }
  };

  const selectServiceProvider = (event: any) => {
    getAllEmail({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        searchValue: event,
        page: page,
        userCategory: ['UTSP', 'UTCUST'],
      },
    });
  };

  useEffect(() => {
    if (EmailResponse.isSuccess) {
      setEmail(EmailResponse.data.data);
    }
  }, [EmailResponse.isSuccess]);

  useEffect(() => {
    if (userData) {
      setNotesValue(userData);
    }
  }, [userData]);

  useEffect(() => {
    if (getnotesData) {
      setNotesData(getnotesData);
    }
  }, [getnotesData]);

  useEffect(() => {
    if (noteDataResponse.isSuccess) {
      dispatch(setNote(noteDataResponse.data));
    }
    if (noteDataResponse.isError) {
      const errorData: any = noteDataResponse.error;
      const msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [noteDataResponse.isSuccess, noteDataResponse.isError]);

  const filteredUsers = notesData;
  const isUserNotFound = filteredUsers.length === 0;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage: any) => {
    setPage(newPage);
    noteData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: newPage,
        userId: selectedOptions.id,
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    noteData({
      token: token.token,
      payload: {
        offset: event.target.value,
        page: 0,
        userId: selectedOptions.id,
      },
    });
  };

  return (
    <Page title="Notes Overview">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Notes Overview
          </Typography>
          <Button
            style={{ color: 'white', backgroundColor: '#E23744' }}
            variant="contained"
            onClick={() => {
              navigate('/dashboard/add-notes', { state: { editMode: true, name: selectedOptions } });
            }}
            startIcon={<Iconify icon="eva:plus-fill" />}
            size="large"
          >
            Add
          </Button>
        </Stack>
        <Card>
          <Box marginTop={'25px'}>
            <Autocomplete
              id="emailId"
              style={{ width: '30%', marginLeft: '20px' }}
              options={email}
              getOptionLabel={(item: any) => (item.email ? `${item.email}` : '')}
              renderInput={(params) => <TextField {...params} label="Search By Comment" variant="outlined" required />}
              onChange={(event: any, value: any) => {
                if (value !== null && value !== '') {
                  selectItems(value);
                }
              }}
              onInputChange={(event: any, value) => {
                if (value !== null && value !== '' && value.length >= 3) {
                  selectServiceProvider(value);
                }
              }}
              clearOnBlur={false}
              clearOnEscape={false}
            />
          </Box>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={notesData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const { id, name, createdByName, createdDate, description } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {description}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {createdByName}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {fDateTimeSuffix(createdDate)}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={notesTotalRecord || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {noteDataResponse.isLoading || EmailResponse.isLoading ? <Loading /> : null}
      </Container>
    </Page>
  );
}
